import styled from 'styled-components'

export const AddNewThreatsButton = styled.div`
  width: 100%;
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid rgba(32, 32, 32, 0.1);
  border-bottom: 1px solid rgba(32, 32, 32, 0.1);
  margin-top: 64px;
  color: #0aa1f4;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  pointer-events: ${(p) => {
    return p.disabled ? 'none' : ''
  }};

  > svg {
    margin-right: 8px;
  }

  path {
    fill: #0aa1f4;
  }
`

export const ThreatRemoveIconWrapper = styled.div`
  height: 32px;
  width: 32px;
  border-radius: 4px;
  display: grid;
  place-items: center;
  user-select: none;
  cursor: pointer;  

  :hover {
    background: rgba(225, 25, 0, 0.05);

    path {
      fill-opacity: 1;
      fill: rgba(225, 25, 0, 1);
    }
  }
`

export const ThreatToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: ${(p) => {
    return p.isActive ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32, 0.7)'
  }};
  gap: 8px;

  path {
    fill: ${(p) => {
    return p.isActive ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32)'
  }};
    fill-opacity: ${(p) => {
    return p.isActive ? '1' : '0.5'
  }};
  }

  :hover {
    color: rgba(10, 161, 244, 1);

    path {
      fill-opacity: 1;
      fill: rgba(10, 161, 244, 1);
    }
  }
`

export const AddNewHabitatsButton = styled.div`
  width: 100%;
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid rgba(32, 32, 32, 0.1);
  border-bottom: 1px solid rgba(32, 32, 32, 0.1);
  margin-top: 64px;
  margin-bottom: 2rem;
  color: #0aa1f4;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  pointer-events: ${(p) => {
    return p.disabled ? 'none' : ''
  }};

  > svg {
    margin-right: 8px;
  }

  path {
    fill: #0aa1f4;
  }
`
